import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function Solution() {
  const steps = [{
    title: 'Nombrar la saturación',
    desc: 'Dejas de pelearte contigo.'
  }, {
    title: 'Muralla Mental',
    desc: 'Responder sin absorber.'
  }, {
    title: 'Protocolo de 15 minutos',
    desc: 'Reset real para tu sistema nervioso.'
  }];
  return <Section alt data-id="element-110">
      <FadeIn data-id="element-111">
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-6" data-id="element-112">
          El método: Aislamiento de Identidad (sin drama)
        </h2>
        <p className="text-lg text-gray leading-relaxed mb-12" data-id="element-113">
          El problema aparece cuando tu valor como persona depende de 'qué tal
          lo has hecho hoy como madre/padre'. Aquí lo separamos. Así, el caos de
          fuera no se convierte en un juicio contra ti.
        </p>
      </FadeIn>

      <StaggerContainer className="space-y-8 mb-16" data-id="element-114">
        {steps.map((step, index) => <StaggerItem key={index} className="flex items-start gap-4" data-id="element-115">
            <div className="w-8 h-8 rounded-full bg-navy text-white flex items-center justify-center font-bold flex-shrink-0 mt-0.5 text-sm" data-id="element-116">
              {index + 1}
            </div>
            <div data-id="element-117">
              <h3 className="font-bold text-charcoal text-lg mb-1" data-id="element-118">
                {step.title}
              </h3>
              <p className="text-gray" data-id="element-119">{step.desc}</p>
            </div>
          </StaggerItem>)}
      </StaggerContainer>

      <FadeIn className="mb-12" data-id="element-120">
        <div className="bg-white p-4 rounded-lg border border-border shadow-sm max-w-sm mx-auto" data-id="element-121">
          <img src="https://cdn.magicpatterns.com/uploads/nqBTePU6cNpRofTmQfaMSk/elpermiso.png" alt="El Permiso — Manual de recuperación de identidad parental" className="w-full rounded object-cover mb-4" data-id="element-122" />
          <p className="text-center text-sm text-gray font-medium" data-id="element-123">
            Formato visual, directo. Hecho para gente sin tiempo.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-124">
        <CTAButton data-id="element-125" />
      </FadeIn>
    </Section>;
}